import { render, staticRenderFns } from "./TemplateStepFormularioMultiplo.vue?vue&type=template&id=2a57c7a0"
import script from "./TemplateStepFormularioMultiplo.vue?vue&type=script&lang=js"
export * from "./TemplateStepFormularioMultiplo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports